import Head from "next/head";

const Meta = ({ title, keyword, desc }) => {
  return (
    <div>
      <Head>
        <title>{title} || GMJA Archive</title>
        <link rel="icon" href="/favicon.png" />
        <meta name="description" content={desc} />
        <meta name="keywords" content={keyword} />
      </Head>
    </div>
  );
};

Meta.defaultProps = {
  title: "GMJA Archive | Discover the Treasures of Ethiopia",
  keyword:
    "GMJA Archive, Ethiopia history, Ethiopian heritage, cultural artifacts, historical records, Ethiopian documents, archival treasures, research, Ethiopian culture, history preservation, GMJA digital archive",
  desc: "Explore the rich cultural heritage and historical treasures of Ethiopia with GMJA Archive. Dive into a vast collection of artifacts, documents, and records preserved for research and discovery.",
};

export default Meta;
